import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import type { Spinner } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';

export interface ISpinner extends Spinner {
  message: string;
}

export enum SPINNER_TYPE {
  BALL_SPIN_CLOCKWISE = 'ball-spin-clockwise'
}

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private readonly defaultOptions: ISpinner = {
    bdColor: 'rgba(51, 51, 51, 0.8)',
    size: 'medium',
    color: '#fff',
    type: SPINNER_TYPE.BALL_SPIN_CLOCKWISE,
    fullScreen: true,
    message: 'Loading...'
  };

  private readonly messageSubject = new BehaviorSubject<string>(this.defaultOptions.message);
  message$ = this.messageSubject.asObservable();

  constructor(private readonly spinner: NgxSpinnerService) { }

  show(customOptions?: ISpinner) {
    const options = { ...this.defaultOptions, ...customOptions };
    this.spinner.show(undefined, options);
    this.messageSubject.next(options.message);
  }

  hide() {
    this.spinner.hide();
  }

  setMessage(newMessage: string) {
    this.messageSubject.next(newMessage);
  }

  setMultipleMessages(messages: { message: string, delay: number }[]) {
    let totalDelay = 0;

    messages.forEach(({ message, delay }) => {
      totalDelay += delay;

      setTimeout(() => {
        this.setMessage(message);
      }, totalDelay);
    });
  }

}
